module.exports = __webpack_public_path__ + "static/img/smile2.023fdde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile2.png
// module id = dpz2
// module chunks = 2